export default {
  catAll: 'Vše',
  catPurchasing: 'Nákup',
  catKeyActivation: 'Aktivace klíče',
  catAccount: 'Účet',
  catBilling: 'Platby',
  catRefunds: 'Vrácení peněz',

  eyebrow: 'FAQ',
  eyebrowSubtitle: 'Najděte odpovědi na časté dotazy',

  title: 'FAQ',
  subtitle: 'Prohledejte databázi nebo filtrujte podle kategorie.',

  heroTitle: 'Často kladené',
  heroTitleAccent: 'dotazy',
  heroSubtitle: 'Přístup k databázi systému navázán. Vyhledejte řešení nebo procházejte kategorie níže.',
  searchPlaceholder: 'DOTAZ...',
  noResults: 'Žádné výsledky. Zkuste jiné hledání nebo kategorii.',

  stillNeedHelpTitle: 'Stále potřebujete pomoc?',
  stillNeedHelpBody: 'Pokud váš dotaz není výše zodpovězen, napište nám a náš tým se vám ozve.',
  contactSupport: 'Kontaktovat podporu',

  q1: 'Jak si koupím herní klíč?',
  q1Intro: 'Nákup klíče na PixelKey je okamžitý, automatizovaný proces. Stačí postupovat podle těchto kroků:',
  q1Step1: 'Procházejte katalog a otevřete hru, kterou chcete.',
  q1Step2: 'Klikněte na „Přidat do košíku“ a poté otevřete košík.',
  q1Step3: 'Přejděte k pokladně a zaplaťte zůstatkem ve své peněžence (v případě potřeby ji nejprve dobijte).',
  q1Step4: 'Jakmile platba proběhne, klíč se okamžitě objeví v sekci „Mé objednávky“ — odkryjte ho a aktivujte.',

  q2: 'Jsou klíče regionálně omezené?',
  q2A: 'Některé klíče mají regionální omezení. Na každé stránce produktu je upozornění „Regionální omezení“, pokud lze klíč aktivovat pouze v určitých regionech; klíče bez regionálního omezení fungují celosvětově. Před nákupem si vždy zkontrolujte stránku produktu.',

  q3: 'Jak dlouho trvá aktivace?',
  q3A: 'Doručení je okamžité — jakmile platba proběhne, klíč je k dispozici v sekci Mé objednávky. Jeho aktivace na platformě (Steam, Epic atd.) obvykle trvá méně než minutu.',

  q4: 'Jak aktivuji svůj klíč?',
  q4A: 'Otevřete Mé objednávky, odkryjte klíč a poté ho uplatněte v příslušném klientovi platformy (např. Steam → Hry → Aktivovat produkt). Každá objednávka obsahuje podrobný návod k aktivaci krok za krokem.',

  q5: 'Jak dobiji svou peněženku?',
  q5A: 'Přejděte na svůj Přehled nebo k Pokladně a klikněte na „Dobít“. Zvolte částku a zaplaťte přes hostovanou pokladnu; zůstatek vaší peněženky se aktualizuje, jakmile bude platba potvrzena.',

  q6: 'Jak ověřím svůj e-mail?',
  q6A: 'Po registraci vám zašleme ověřovací odkaz e-mailem. Kliknutím na něj ověříte svou adresu — tím se odemknou nákupy až do výše 50 €. V případě potřeby ho můžete znovu odeslat ze svého Přehledu.',

  q7: 'Mohu smazat svůj účet?',
  q7A: 'Ano. V Nastavení účtu → Nebezpečná zóna můžete naplánovat smazání. Váš účet bude odstraněn po 7denní ochranné lhůtě a kdykoli předtím můžete smazání zrušit.',

  q8: 'Jaké jsou podmínky vrácení peněz?',
  q8A: 'Neodkryté klíče lze vrátit. Jakmile je klíč odkryt nebo aktivován, nelze ho vrátit, protože digitální klíče jsou nevratné. Pokud se s vaší objednávkou něco pokazilo, kontaktujte podporu.',

  q9: 'Jaké platební metody přijímáte?',
  q9A: 'Platíte ze zůstatku své peněženky PixelKey. Dobijte ji kartou přes naši hostovanou pokladnu — peněženka pak okamžitě pokryje jakoukoli objednávku, aniž bychom na našich serverech ukládali údaje o kartě.',

  q10: 'Kde najdu zakoupené klíče?',
  q10A: 'Každý klíč najdete v sekci Mé objednávky. Otevřete objednávku, klikněte na odkrýt a zobrazí se aktivační kód — každé odkrytí je z bezpečnostních důvodů zaznamenáno.',

  q11: 'Potřebuji k nákupu účet?',
  q11A: 'Ano. Bezplatný účet propojí vaše objednávky, zůstatek peněženky a klíče s vámi, takže jsou vaše nákupy vždy dohledatelné. Registrace zabere méně než minutu — stačí e-mail a heslo.',

  q12: 'Jsou mé platební údaje v bezpečí?',
  q12A: 'Údaje o kartě se nikdy nedostanou na naše servery — platby zpracovává náš poskytovatel splňující PCI přes hostovanou pokladnu. Ukládáme pouze zůstatek vaší peněženky, nikdy vaši kartu.',

  q13: 'Kde uvidím historii nákupů?',
  q13A: 'Kompletní historii objednávek a peněženky najdete v Účet → Platby: každý nákup, dobití a transakci s daty a částkami.',

  q14: 'Jak požádám o vrácení peněz?',
  q14A: 'Pokud je klíč stále neodkrytý, kontaktujte podporu v sekci „Stále potřebujete pomoc“ níže s číslem objednávky a my vám částku vrátíme do peněženky. Odkryté klíče vrátit nelze.',

  q15: 'Moje objednávka uvízla ve stavu „zpracování“ — co mám dělat?',
  q15A: 'Většina objednávek se doručí během několika sekund, ale během kontroly u dodavatele může objednávka krátce zůstat ve stavu ZPRACOVÁNÍ. Pokud se nevyřídí do několika minut, kontaktujte podporu s číslem objednávky a my to vyřešíme nebo vám vrátíme peníze.',
};
